import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Text, HStack, Image, Button, useStyleConfig} from '@chakra-ui/react'
import {TextTitleDescription} from '../../text-title-description'
import {ChevronRight} from '../../../icons'
import {remCalc} from '../../../../theme/_utils'
import CustomLink from '../../../custom-link'
import {useGetCategoriesData} from '../../../../custom-api/hooks/use-get-categories-data'
import {getGlobalLink} from '../../../../utils/contentstack-utils'
import useDamImage from '../../../../custom-hooks/use-dam-image'
import {BRAND_KEY} from '../../../../brand'
import {useProducts} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const PromoSlideCard = ({title, bodyCopy, button, url, alt, image}) => {
    const styles = useStyleConfig('PromoSlider')
    const categoriesData = useGetCategoriesData()
    const {locale} = useMultiSite()
    const {data: productsData} = useProducts(
        {
            parameters: {
                ids: button?.productsfcc?.data?.length > 0 ? button.productsfcc.data[0].id : '',
                expand: ['availability', 'images'],
            },
            headers: {
                'x-debug': 'promo-slider-index',
            },
        },
        {
            enabled: button?.productsfcc?.data?.length > 0,
        },
    )
    const {
        url: ctaUrl,
        label: ctaLabel,
        isAbsolute,
    } = getGlobalLink({
        link: button,
        categoriesData,
        productsData,
        locale: locale?.alias || locale?.id?.toLowerCase(),
    })
    const {url: imageUrl} = useDamImage(image)

    const isKenwood = BRAND_KEY === 'kenwood'

    // const handleRedirect = (e) => {
    //     e.preventDefault()
    //     if (cta && cta?.href) {
    //         isExternalUrl ? window.open(cta.href, '_blank') : navigate(cta.href)
    //     }
    // }

    const imageToDisplay = imageUrl || url

    return (
        <CustomLink
            sx={styles.sliderLinkContainer}
            isExternal={isAbsolute}
            href={ctaUrl}
            data-testid="promo-slide-card-link"
        >
            <Flex sx={styles.sliderContainer} data-testid={`swiper-slide-${title || 'container'}`}>
                <Box sx={styles.imageContainer} data-testid="promo-slider-image-container">
                    <Image
                        src={imageToDisplay}
                        alt={alt}
                        loading="lazy"
                        {...styles.promoSliderImage}
                        data-testid="promo-slider-image"
                    />
                </Box>
                <Flex sx={styles.contentContainer}>
                    <TextTitleDescription title={title} {...styles.textTitleDescription}>
                        {bodyCopy}
                    </TextTitleDescription>
                    {ctaLabel && (
                        <Button
                            {...styles.promoSliderCardButton}
                            aria-label={ctaLabel}
                            tabIndex={0}
                        >
                            <HStack gap={remCalc(10)}>
                                <Text as="span" {...styles.promoSlideCardText}>
                                    {ctaLabel}
                                </Text>
                                {!isKenwood && (
                                    <ChevronRight
                                        aria-label="right icon"
                                        {...styles.imageCardChevronIcon}
                                    />
                                )}
                            </HStack>
                        </Button>
                    )}
                </Flex>
            </Flex>
        </CustomLink>
    )
}

PromoSlideCard.propTypes = {
    title: PropTypes.string,
    bodyCopy: PropTypes.string,
    button: PropTypes.object,
    url: PropTypes.string,
    alt: PropTypes.string,
    image: PropTypes.object,
}

export default PromoSlideCard
